import { camelCase } from 'lodash'

const requireContext = require.context('./modules/', false, /[A-Za-z]\w+\.routes.(js)$/)

const routers = requireContext.keys()
  .map(fileName => (requireContext(fileName).default)) // 读取routers并返回内容
  .sort((p, n) => p.sort - n.sort) // 排序
  .reduce((p, n) => { // 返回routers
    return [...p, ...n.routers]
  }, [])

const routeNameGenerator = routers => {
  routers.forEach(it => {
    it.name = it.path === '/' ? 'root' : camelCase(it.path.split('/').join(''))
    if (it.children) {
      routeNameGenerator(it.children)
    }
  })
}

routeNameGenerator(routers)

export default routers
